import { Component, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { LogViewer } from '../../../pages/log-viewer/log-viewer';
import { LogService } from '../../../core/services/log.service';

@Component({
  selector: 'app-footer',
  standalone: true,
  imports: [CommonModule, RouterModule, LogViewer],
  templateUrl: './footer.html',
  styleUrl: './footer.scss'
})
export class Footer {
  @ViewChild('logViewer') logViewer!: LogViewer;
  private tapCount = 0;
  private tapTimer: any;

  currentYear = new Date().getFullYear();

  constructor(private log: LogService) {}

  navigation = [
    { label: 'Accueil', route: '/' },
    { label: 'Favoris', route: '/favorites' },
    { label: 'Carte', route: '/map' },
  ];

  legal = [
    { label: 'Mentions légales', route: '/mentions-legales' },
    { label: 'Politique de confidentialité', route: '/politique-confidentialite' },
    { label: 'Contact', route: '/contact' },
  ];

  onOpenLogViewer(){
    this.tapCount++;

    // Reset après 2 secondes d'inactivité
    clearTimeout(this.tapTimer);
    this.tapTimer = setTimeout(() => { this.tapCount = 0; }, 2000);
    
    if (this.tapCount >= 5) {
      this.tapCount = 0;
      clearTimeout(this.tapTimer);
      this.log.log('Log viewer ouvert via raccourci');
      this.logViewer.open();
    }
  }
}
